<template>
  <div class="vitalsigns">
    <vs-button
      @click="handleOpenModalCreateVitalSigns"
      class="btn-vital mr-1"
      type="relief"
      ><i class="fas fa-heartbeat mr-1"></i>SINAIS VITAIS (SSVV)</vs-button
    >
    <!-- modal create vital signs -->
    <b-modal
      no-close-on-backdrop
      hide-footer
      id="popupVitalSigns"
      title="ADICIONAR SINAIS VITAIS (SSVV)"
    >
      <div class="row">
        <div class="col-md-12">
          <h6 class="worksansr">TIPO DE MEDIÇÃO VITAL</h6>
          <select
            @change="handleChangeVitalSigns($event.target.value)"
            v-model="type"
            class="form-control"
          >
            <option value="">SELECIONE...</option>
            <option :key="item.id" :value="item.name" v-for="item in types">
              {{ item.name }}
              {{ item.abbreviation ? ` - ${item.abbreviation}` : "" }}
            </option>
          </select>
        </div>
        <div
          v-if="show_capillary_glycemia"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
        >
          <h6 class="worksansr">KIT:</h6>
          <select v-model="product_kit_id" class="form-control">
            <option :key="item.id" :value="item.id" v-for="item in kits">
              {{ item.description }}
            </option>
          </select>
        </div>
        <div
          v-show="type == 'DOR'"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0"
        >
          <h6 class="mb-1 color-blue text-for">DOR - ESCALA EVA:</h6>
          <div class="row">
            <div
              class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6 border-right text-center"
            >
              <img width="25" src="../../../../assets/emoji/1.png" />
              <h6 class="mb-0 text-for">SEM DOR</h6>
              <span class="worksansr">0</span>
            </div>
            <div
              class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6 border-right text-center"
            >
              <img width="25" src="../../../../assets/emoji/1.png" />
              <h6 class="mb-0 text-for">LEVE</h6>
              <span class="worksansr">1-3</span>
            </div>
            <div
              class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6 border-right text-center"
            >
              <img width="25" src="../../../../assets/emoji/3.png" />
              <h6 class="mb-0 text-for">MODERADA</h6>
              <span class="worksansr">4-7</span>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6 text-center">
              <img width="25" src="../../../../assets/emoji/4.png" />
              <h6 class="mb-0 text-for">INTENSA</h6>
              <span class="worksansr">8-10</span>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="input-group">
            <input
              v-if="show_description"
              type="text"
              class="form-control"
              v-model="description"
              placeholder="VALOR"
            />

            <select
              v-if="show_diuresis"
              v-model="description"
              class="form-control"
            >
              <option value="">SELECIONE...</option>
              <option
                :key="key"
                :value="item"
                v-for="(item, key) in types_diuresis"
              >
                {{ item }}
              </option>
            </select>

            <select
              v-if="show_evacuation"
              v-model="description"
              class="form-control"
            >
              <option value="">SELECIONE...</option>
              <option
                :key="key"
                :value="item"
                v-for="(item, key) in types_evacuation"
              >
                {{ item }}
              </option>
            </select>
            <div
              v-if="show_blood_pressure"
              class="input-group-pprend d-flex align-items-center pl-2 pr-2"
            >
              POR
            </div>

            <input
              v-if="show_blood_pressure"
              type="text"
              class="form-control"
              v-model="final_description"
              placeholder="VALOR"
            />
            <div v-if="show_icon" class="input-group-pprend">
              <v-btn disabled><i :class="icon" /></v-btn>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <label>OBSERVAÇÃO</label>
          <ChromeSpeechToTextTextarea rows="4" max-rows="10" v-model="note" />
        </div>
        <div class="col-md-12 pt-0">
          <ErrorsMessages :errors="errors" />
        </div>
      </div>
      <div class="row back-groung-greytwo mt-4">
        <div
          class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 check-text-center pb-0"
        >
          <h6 class="upper-text">LISTA DE SINAIS VITAIS ADICIONADOS</h6>
        </div>
        <div
          class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 check-text-right nb-margin pb-0"
        >
          <v-btn class="btn-add-down" @click="handleAddVitalSigns">
            <i class="fas fa-arrow-down mr-2 text-twenty"></i> ADICIONAR À LISTA
          </v-btn>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <v-data-table
            dense
            :headers="[
              { text: 'TIPO', value: 'type' },
              { text: 'DESCRIÇÃO', value: 'description' },
              { text: 'OBSERVAÇÃO', value: 'note' },
              { text: 'AÇÕES', value: 'actions' },
            ]"
            :items="vital_signs"
            :footer-props="{
              'items-per-page-options': [50, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
          >
            <template v-slot:[`item.description`]="{ item }">
              {{ item.title }} {{ item.description }}
              {{
                item.type == "DOR"
                  ? `(${handleDescriptionAche(item.description)})`
                  : item.abbreviation
              }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <confirmation-dialog
                message-title="CONFIRMAÇÃO"
                message-body="TEM CERTEZA QUE DESEJA REMOVER?"
                open-class="btn-delete"
                open-text="REMOVER"
                small
                @yes="deleteVitalSigns(item.id)"
              />
            </template>
          </v-data-table>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right">
          <v-btn :disabled="loadingCreate" @click="create" class="btn-save">
            <i class="fas fa-save mr-2 text-twenty"></i>
            {{ loadingCreate ? "Carregando" : "SALVAR" }}
          </v-btn>
        </div>
      </div>
    </b-modal>
    <!-- /modal create vital signs -->
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";

import ChromeSpeechToTextTextarea from "../../../Components/ChromeSpeechToTextTextarea";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

import { formatDate, generateId, isNumeric } from "../../../../lib/format";

import routes from "../../../../routes";
import ConfirmationDialog from "../../../Components/ConfirmationDialog.vue";

export default {
  name: "VitalSigns",
  components: {
    ErrorsMessages,
    ChromeSpeechToTextTextarea,
    ConfirmationDialog,
  },
  props: {
    rest_home_id: [String, Number],
    resident_id: [String, Number],
    user_id: [String, Number],
  },
  data() {
    return {
      feeding_care_responses: [
        { id: 1, response: "PARCIAL" },
        { id: 2, response: "BOA ACEITAÇÃO" },
        { id: 3, response: "NÃO ACEITOU" },
        { id: 4, response: "ACEITAÇÃO TOTAL" },
      ],
      product_kit_id: "",
      kits: [],
      vital_signs: [],
      types: [
        {
          id: 7,
          name: "DIURESE",
          abbreviation: "",
        },
        { id: 5, name: "DOR", abbreviation: "" },
        {
          id: 8,
          name: "EVACUAÇÃO",
          abbreviation: "",
        },
        {
          id: 4,
          name: "FREQUÊNCIA RESPIRATÓRIA",
          abbreviation: "(R) irpm",
        },
        {
          id: 6,
          name: "GLICEMIA CAPILAR",
          abbreviation: "(DX) mg/dl",
        },
        {
          id: 2,
          name: "PULSO (FREQUÊNCIA CARDÍACA)",
          abbreviation: "(P) - BPM",
        },
        { id: 3, name: "PRESSÃO ARTERIAL", abbreviation: "(P.A) mmHg" },
        {
          id: 9,
          name: "SATURAÇÃO DE OXIGÊNIO",
          abbreviation: "%",
        },
        { id: 1, name: "TEMPERATURA CORPORAL", abbreviation: "(T) ºC" },
      ],
      types_diuresis: [
        "AUSÊNCIA DE DIURESE",
        "DIURESE PRESENTE",
        "POUCA DIURESE",
      ],
      types_evacuation: [
        "AUSENTE",
        "BEM MOLDADAS",
        "EM CÍBALOS",
        "LÍQUIDA",
        "PASTOSA",
      ],
      type: "",
      description: "",
      final_description: "",
      title: "",
      abbreviation: "",
      note: "",
      loading: true,
      loadingCreate: false,
      show_description: true,
      show_capillary_glycemia: false,
      show_blood_pressure: false,
      show_icon: false,
      show_diuresis: false,
      show_evacuation: false,
      icon: "",
      errors: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatDate,
    generateId,
    handleChangeVitalSigns(value) {
      this.show_blood_pressure = false;
      this.show_capillary_glycemia = false;
      this.show_diuresis = false;
      this.show_evacuation = false;
      this.show_description = false;

      switch (String(value)) {
        case "TEMPERATURA CORPORAL":
          this.title = "(T)";
          this.abbreviation = "ºC";
          this.show_description = true;
          break;
        case "PULSO (FREQUÊNCIA CARDÍACA)":
          this.title = "(P)";
          this.abbreviation = "BPM";
          this.show_description = true;
          break;
        case "PRESSÃO ARTERIAL":
          this.title = "(P.A)";
          this.abbreviation = "mmHg";
          this.show_description = true;
          this.show_blood_pressure = true;
          break;
        case "FREQUÊNCIA RESPIRATÓRIA":
          this.title = "(R)";
          this.abbreviation = "irpm";
          this.show_description = true;
          break;
        case "DOR":
          this.title = "DOR";
          this.abbreviation = "";
          this.show_description = true;
          break;
        case "GLICEMIA CAPILAR":
          this.title = "(DX)";
          this.abbreviation = "mg/dl";
          this.show_description = true;
          this.show_capillary_glycemia = true;
          break;
        case "DIURESE":
          this.title = "";
          this.abbreviation = "";
          this.show_diuresis = true;
          break;
        case "EVACUAÇÃO":
          this.title = "";
          this.abbreviation = "";
          this.show_evacuation = true;
          break;
        case "SATURAÇÃO DE OXIGÊNIO":
          this.title = "";
          this.abbreviation = "%";
          this.show_description = true;
          break;
      }
    },
    handleDescriptionAche(nivel) {
      if (parseInt(nivel) == 0) {
        return "SEM DOR";
      } else if (parseInt(nivel) >= 1 && parseInt(nivel) <= 3) {
        return "DOR LEVE";
      } else if (parseInt(nivel) >= 4 && parseInt(nivel) <= 7) {
        return "DOR MODERADA";
      } else if (parseInt(nivel) >= 8 && parseInt(nivel) <= 10) {
        return "DOR INTENSA";
      }
    },
    async retrieve() {
      await this.getKits();
    },
    async getKits() {
      try {
        const { rest_home_id } = this;

        var params = { rest_home_id };

        const response = await api.get(
          "/rest-home/product/kit/get/with/products/added",
          {
            params,
          }
        );

        const { error, kits } = response.data;

        if (!error) {
          this.kits = kits;
        }
      } catch (error) {
        console.log(error);
      }
    },
    handleOpenModalCreateVitalSigns() {
      // this.$emit("popup");
      this.$bvModal.show("popupVitalSigns");
    },
    handleAddVitalSigns() {
      let {
        description,
        final_description,
        type,
        title,
        abbreviation,
        note,
        product_kit_id,
      } = this;

      if (!type) {
        this.errors = [{ id: 1, message: "Informe o tipo de medição" }];
        return;
      }

      var types = [
        "TEMPERATURA CORPORAL",
        "PULSO (FREQUÊNCIA CARDÍACA)",
        "PRESSÃO ARTERIAL",
        "FREQUÊNCIA RESPIRATÓRIA",
        "DOR",
        "GLICEMIA CAPILAR",
        "DIURESE",
        "EVACUAÇÃO",
        "SATURAÇÃO DE OXIGÊNIO",
      ];

      if (!types.includes(type)) {
        this.errors = [{ id: 1, message: "Informe tipo de medição" }];
        return;
      }

      if (!description) {
        this.errors = [{ id: 1, message: "Informe todos os campos" }];
        return;
      }

      if (type == "PRESSÃO ARTERIAL") {
        if (!final_description) {
          this.errors = [{ id: 1, message: "Informe todos os campos" }];
          return;
        }
      }

      if (type == "DOR") {
        if (!isNumeric(description)) {
          this.errors = [{ id: 1, message: "Informe apenas números" }];
          return;
        }

        if (parseInt(description) > 10) {
          this.errors = [{ id: 1, message: "Informe número entre [0, 10]" }];
          return;
        }
      }

      if (type == "TEMPERATURA CORPORAL") {
        let validate_description = String(description)
          .replace(",", "")
          .replace(".", "");

        if (!isNumeric(validate_description)) {
          this.errors = [{ id: 1, message: "Informe apenas números" }];
          return;
        }

        description = String(description).replace(",", ".");
      }

      if (
        type != "DIURESE" &&
        type != "EVACUAÇÃO" &&
        type != "TEMPERATURA CORPORAL"
      ) {
        if (!isNumeric(description)) {
          this.errors = [{ id: 1, message: "Informe apenas números" }];
          return;
        }
        if (type == "PRESSÃO ARTERIAL") {
          if (!isNumeric(final_description)) {
            this.errors = [{ id: 1, message: "Informe apenas números" }];
            return;
          }
          if (parseInt(description) < 29) {
            this.errors = [{ id: 1, message: "Informe valor acima de 29x39" }];
            return;
          }
          if (parseInt(final_description) < 39) {
            this.errors = [{ id: 1, message: "Informe valor acima de 29x39" }];
            return;
          }
        }
      }

      let initial_description = "";
      if (type == "PRESSÃO ARTERIAL") {
        initial_description = description;
        description = `${description}X${final_description}`;
      }

      var obj = {
        id: generateId(),
        type,
        description,
        initial_description,
        final_description,
        title,
        abbreviation,
        note,
        product_kit_id,
      };

      this.vital_signs.push(obj);

      this.type = "";
      this.description = "";
      this.note = "";
      this.final_description = "";
      this.show_capillary_glycemia = false;
      this.product_kit_id = "";
      this.errors = [];
    },
    deleteVitalSigns(id) {
      try {
        const { vital_signs } = this;

        vital_signs.map((item, key) => {
          if (item.id == id) {
            vital_signs.splice(key, 1);
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    async create() {
      try {
        this.loadingCreate = true;

        const { type } = this.$attrs;

        const { rest_home_id, resident_id, user_id, vital_signs } = this;

        var params = {
          rest_home_id,
          resident_id,
          user_id,
          vital_signs,
          type,
        };

        const response = await api.post("/rest-home/vital-sign/create", params);

        const { error, errors, message, care_id } = response.data;

        if (!error) {
          toast(message, "success");
          this.$bvModal.hide("popupVitalSigns");
          this.$emit("created");
          routes.push({ name: "vital_sign", params: { id: care_id } });
        } else {
          this.errors = errors;
        }

        this.loadingCreate = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
.align-emoticon {
  margin: 0 auto;
}

.emoticon {
  width: 112px;
  height: auto;
  border-right: 1px solid #f1f1f1;
}

.text-emoticon {
  font-size: 12px;
  font-weight: 600;
}
</style>
